import React, { useState, memo } from 'react'
import ServiceItemCheckbox from './ServiceItemCheckbox'
import CarModalInput from '../../../../inputs/CarModalInput'
import TextAreaInput from '../../../../inputs/TextAreaInput'
import SubmitButton from '../../../../buttons/SubmitButton'
import ServicesStaticItem from './ServicesStaticItem'
import { cleanList } from '../../../../../functions/stateList'
import Skeleton from '../../../../skeleton/Skeleton'
import { getData } from '../../../../../assets/scripts/GeneralFunctions'
import { useLocation, useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import TireServiceData from './TireServiceData'

function ServiceItemContent({ isLoading, activeFilter, types, activeId, productWithType }) {
  const [isSubmit, setIsSubmit] = useState(false)
  const [services, setServices] = useState([])
  const [inputs, setInputs] = useState({
    current_km: '',
    description: '',
  })
  const [errors, setErrors] = useState({
    current_km: '',
    description: '',
  })
  const location = useLocation()
  const navigate = useNavigate()

  const inputHandler = (e) => {
    setInputs({
      ...inputs,
      [e.target.name]: e.target.value,
    })
    setErrors({
      ...errors,
      [e.target.name]: '',
    })
  }
  const formHandler = async (e) => {
    e.preventDefault()
    const queryParams = {
      current_km: inputs.current_km,
      description: inputs.description,
      services,
    }
    setIsSubmit(true)
    const apiResult = await getData(
      `admin/visits/create/${location?.state?.carId}`,
      'post',
      queryParams,
      true,
      true
    )
    if (apiResult?.status === 200) {
      navigate(-1)
      toast.success('سرویس مورد نظر با موفقیت ثبت شد')
      setIsSubmit(false)
    } else {
      setIsSubmit(false)
      setErrors(apiResult?.error)
      for (const property in apiResult?.error) {
        toast.error(`${apiResult?.error[property]}`)
      }
    }
  }

  return (
    <form onSubmit={formHandler}>
      {isLoading ? (
        <Skeleton loadingData={true} />
      ) : (
        <div className="bg-sky-50 dark:bg-slate-700 dark:border-gray-700 border border-light-gray rounded-lg my-6 py-6 md:py-8 px-6 md:px-16">
          <div className={'grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4'}>
            {(activeId === 1 || activeId === 2) &&
              types &&
              types.map(
                (type, index) =>
                  productWithType[type]?.length > 0 && (
                    <div key={index}>
                      <ServiceItemCheckbox
                        activeFilter={activeFilter}
                        activeId={activeId}
                        label={type}
                        // name={index}
                        list={productWithType[type]}
                        services={services}
                        setServices={setServices}
                      />
                    </div>
                  )
              )}

            {activeId === 3 && (
              <TireServiceData
                activeFilter={activeFilter}
                services={services}
                setServices={setServices}
              />
            )}

            {activeId === 4 && (
              <ServicesStaticItem
                activeFilter={activeFilter}
                list={cleanList}
                services={services}
                setServices={setServices}
              />
            )}
          </div>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
        {/*<CarModalSelect*/}
        {/*  name={'next_visit'}*/}
        {/*  value={inputs?.next_visit}*/}
        {/*  error={errors}*/}
        {/*  title={'مراجعه بعدی'}*/}
        {/*  inputHandler={inputHandler}*/}
        {/*  list={visitList}*/}
        {/*  text_key={'value'}*/}
        {/*/>*/}

        <CarModalInput
          maxLength={9}
          type={'number'}
          name={'current_km'}
          value={inputs?.current_km}
          error={errors}
          title={'کیلومتر فعلی'}
          inputHandler={inputHandler}
        />
      </div>

      <TextAreaInput
        name={'description'}
        value={inputs?.description}
        error={errors}
        title={'توضیحات'}
        inputHandler={inputHandler}
      />

      <div className="flex justify-center mt-12">
        <SubmitButton isSubmit={isSubmit} wFit={true} />
      </div>
    </form>
  )
}

export default memo(ServiceItemContent)
